import React from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { selectStyle } from "../../models/selectStyle";
import { templateActions } from "../../../store/actions/cms/template/template.action";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  Tooltip,
} from "@material-ui/core";
import { deepClone } from "../../../helpers/objectHelper";
import Alert from "@material-ui/lab/Alert";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import { history } from "../../../helpers/history";

const EventSelector = (props) => {
  const {
    template,
    templates,
    dialog,
    dispatch,
    templateIsSavable,
    updateLayout,
  } = props;

  
  const { eventName, eventId, events, icon = true } = props;
  return (
    <>
      <FormGroup
        style={{
          padding: "10px",
          margin: 0,
          display: "flex",
          alignItems: "center",
          paddingBottom: 0,
        }}
      >
        {icon ? (
          <Tooltip title={<SystemLabel name="CurrentEvent" />}>
            <CalendarTodayOutlinedIcon
              className="secondary-text"
              style={{ fontSize: 20, marginTop: -5 }}
            />
          </Tooltip>
        ) : null}
        <Select
          classsName="jirango-select"
          options={
            events
              ? events.map((t) => {
                  return { value: t.eventId, label: t.name };
                })
              : []
          }
          value={{ value: eventId, label: eventName }}
          onChange={(opt) => {
            const selEvent = events.find((e) => e.eventId == opt.value);
            if (selEvent) {
              history.push(`/editor/${selEvent.code}`);
            }
          }}
          styles={{
            ...selectorStyle,
          }}
        />
      </FormGroup>
    </>
  );
};

export const selectorStyle = {
  container: (provided, state) => ({
    ...provided,
    width: "100%",
  }),
  control: (provided, state) => ({
    ...provided,

    backgroundColor: "#50525d",
    color: "#eee",
    border: "0px",
    maxWidth: "100%",
    width: "100%",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: "green",
    maxWidth: "100%",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "#eee",
    maxWidth: "100%",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#eee",
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    background: "transparent",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#373842",
    maxWidth: "100%",
    zIndex: 100,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#20a8d8" : "#3d3d3d",
    color: "#eee",
    ["&:hover"]: {
      backgroundColor: "#5a5959ba",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#eee",
  }),
};

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    alert: state.alert,
    page: state.page,
    template: state.template.template,
    language: state.language,
    templateIsSavable: state.template.isSavable,
    templates: state.template ? state.template.templates : undefined,
    systemLabel: state.systemLabel,
  };
}
export default connect(mapStateToProps)(EventSelector);
